export const Events = {
  RESULTS_RECEIVED: "resultsReceived"
};

export const ErrorMessages = {
  REQUEST_FAILED: "Request to resource has failed"
};
